module.exports = __webpack_public_path__ + "img/85B9D3_C9EAF9_417277_528789-256px.013696af.png";